const dataMenu = [
  {
    id: 1,
    name: 'Map Analytic',
    code: 'map-analytic',
    icon: 'mapAnalytic',
    status: true,
    permission: 'MAPANA',
    children: [
      {
        id: 0,
        name: 'Site Profiling',
        code: 'site-profiling',
        icon: 'siteProfiling',
        step: 'SITE_PROFILING',
        active: true,
        permission: 'MAPANA.SIPRO',
      },
      {
        id: 1,
        name: 'Grid Analysis',
        code: 'grid-analysis',
        step: 'GRID_ANALYTIC',
        icon: 'gridAnalysis',
        active: true,
        permission: 'MAPANA.GRIANA',
      },
      {
        id: 3,
        name: 'Site Profiling Mandala',
        code: 'site-profiling-mandala',
        icon: 'siteProfiling',
        step: 'SITE_PROFILING',
        active: true,
        permission: 'RND.SIPRO-MANDALA',
      },
      {
        id: 4,
        name: 'Grid Analysis Lawu',
        code: 'grid-analysis-lawu',
        step: 'GRID_ANALYTIC',
        icon: 'gridAnalysis',
        active: true,
        permission: 'RND.GRIANA-LAWU',
      },
      {
        id: 2,
        name: 'Asset Management Telkom Property',
        code: 'asman-telkom',
        step: 'ASMAN_TELKOM',
        icon: 'assetManagement',
        active: true,
        permission: 'MAPANA.ASMANTELKOM',
      },
      {
        id: 4,
        name: 'NFR Business Analysis',
        code: 'asset-management-pertamina',
        step: 'ASMAN_PERTAMINA',
        icon: 'pertaminaIcon',
        active: true,
        permission: 'MAPANA.ASMANPERTAMINA',
      },
      {
        id: 4,
        name: 'Tenant Suitability Analysis',
        code: 'tenant-suitability-analysis',
        step: 'TENANT_SUITABILITY',
        icon: 'tenantsuitability',
        active: true,
        permission: 'MAPANA.TENANTSUITABILITY',
      },
      {
        id: 4,
        name: 'Area Profiling',
        code: 'danone-area-profiling',
        step: 'DANONE_AREA_PROFILING',
        icon: 'siteProfiling',
        active: true,
        permission: 'MAPANA.DANONE.AREA_PROFILING',
      },
      {
        id: 4,
        name: 'Territory Planning',
        code: 'danone-territory-planning',
        step: 'DANONE_TERRITORY_PLANNING',
        icon: 'businessProfiling',
        active: true,
        permission: 'MAPANA.DANONE.TERRITORY_PLANNING',
      },
    ],
  },
];

export default dataMenu;
